import { createEvent, restore } from 'effector';

export const setCurrentUuid = createEvent<string>();
export const $currentUuid = restore(setCurrentUuid, '');
